<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Table :columns="columns8" :data="row.rows"> </Table>
    </Row>
    <Modal
      v-model="laiyuantishi"
      title="提醒"
      @on-ok="quedinglaiyuan"
      @on-cancel="laiyuantishi = false"
    >
      <p>{{ laiyuantitle }}</p>
    </Modal>

    <Modal
      v-model="caidanmodal"
      title="提醒"
      @on-ok="caidanok"
      @on-cancel="caidanmodal = false"
    >
      <div>
        <div style="margin-bottom: 8px">请输入拆单数量</div>
        <Input
          v-model="chaiCount"
          placeholder="请输入拆单数量"
          style="width: 200px"
        />
        <div style="margin-top: 8px; color: #999">
          最大可拆：{{ maxChaiCount }}
        </div>
      </div>
    </Modal>
    <Modal
      v-model="chaiConfirmModal"
      title="提醒"
      @on-ok="chaiConfirmOk"
      @on-cancel="chaiConfirmModal = false"
    >
      <p>确定拆成独立订单吗?</p>
    </Modal>
    <Modal
      v-model="updateSource"
      title="修改商品来源"
      @on-ok="updateSourceModalOk"
      @on-cancel="updateSource = false"
    >
      <Select v-model="selectedSource" placeholder="请选择商品来源">
        <Option
          v-for="item in goodsource"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </Option>
      </Select>
    </Modal>
    <Modal
      v-model="costModal"
      title="修改商品成本"
      @on-ok="updateCost"
      @on-cancel="costModal = false"
    >
      <Input v-model="newCost" placeholder="请输入新的成本价"  />
    </Modal>
  </div>
</template>
<script>
import { cmsChaiOrder, cmsCaigouOrder, cmsUpdateSource,cmsUpdateCost } from "../../api/fahuo";
const GOODS_SOURCE = [
  { value: "本地库", label: "本地库" },
  { value: "山东七尊--徕芬", label: "山东七尊--徕芬" },
  { value: "慧采--摩飞", label: "慧采--摩飞" },
  { value: "品胜电器", label: "品胜电器" },
  { value: "上海快愉--美妆", label: "上海快愉--美妆" },
  { value: "SONGX耳机", label: "SONGX耳机" },
  { value: "GERM水杯厂家", label: "GERM水杯厂家" },
  { value: "春晓明亮--汉印BKT", label: "春晓明亮--汉印BKT" },
  { value: "上海百事得--罗技 JBL", label: "上海百事得--罗技 JBL" },
  { value: "赛罕正黄芪茶", label: "赛罕正黄芪茶" },
  { value: "GISO潮玩", label: "GISO潮玩" },
  { value: "醒刻--电动指甲刀", label: "醒刻--电动指甲刀" },
  { value: "苏氏陶瓷茶具", label: "苏氏陶瓷茶具" },
  { value: "鑫爵集第", label: "鑫爵集第" },
  { value: "合肥双源鸿业--膳魔师", label: "合肥双源鸿业--膳魔师" },
  { value: "炊大皇", label: "炊大皇" },
  { value: "伯希和户外", label: "伯希和户外" },
  { value: "简健农业--陈皮", label: "简健农业--陈皮" },
  { value: "派克笔礼盒", label: "派克笔礼盒" },
  { value: "云客-美妆", label: "云客-美妆" },   
  { value: "西屋电器", label: "西屋电器" },   
  { value: "金不换实业", label: "金不换实业" },   
  { value: "能太国际", label: "能太国际" },   
  { value: "若来拼图", label: "若来拼图" },   
  { value: "定制有链接-代付", label: "定制有链接-代付" },   
  { value: "千岛闪购-代付", label: "千岛闪购-代付" },   
  { value: "北京格物--洛克代发", label: "北京格物--洛克代发" },   
  { value: "大连半人马商贸-于永刚家", label: "大连半人马商贸-于永刚家" },   
  { value: "心心潮玩", label: "心心潮玩" },   
  { value: "Zigo咖啡", label: "Zigo咖啡" },   
  { value: "上海青柠", label: "上海青柠" },   
  { value: "洛克科技-阿里", label: "洛克科技-阿里" },   
  { value: "香薰-阿里", label: "香薰-阿里" },   
  { value: "乐高代发", label: "乐高代发" },   
];
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      goodsource: GOODS_SOURCE,
      laiyuantitle: "",
      selectedSource: "", // 选中的商品来源
      datanum: this.row.rows,
      laiyuantishi: false,
      caidanmodal: false,
      chaiCount: "",
      maxChaiCount: 0,
      chaiConfirmModal: false,
      updateSource: false,
      costModal: false,
      newCost: "",
      currentGoodsId: null,
      selrow: {},
    };
  },
  computed: {
    columns8() {
      const baseColumns = [
        {
          title: "商品id",
          key: "goodsid",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "商品图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: process.env.OSS  + params.row.goodsimg,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },
        {
          title: "商品成本",
          key: "cost",
          render: (h, params) => {
            const cost = params.row.cost;
            const goodsnum = params.row.goodsnum;
            return h("span", cost * parseInt(goodsnum));
          },
        },
        {
          title: "商品类型",
          key: "goodstype",
        },
        {
          title: "商品来源",
          key: "goodssource",
        },
        {
          title: "采购状态",
          key: "procurestatus",
          render: (h, params) => {
            const procurestatus = params.row.procurestatus;
            return h("span", procurestatus === 0 ? "未采购" : "已采购");
          },
        },
      ];

      // 如果 ordetype 不是 1 或 4，则添加操作列
      if (
        this.row.rows[0].ordertype !== 1 &&
        this.row.rows[0].ordertype !== 4
      ) {
        baseColumns.push({
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerReturnOrder", [params.row]);
                    },
                  },
                },
                "退回"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.costModal = true;
                      this.currentGoodsId = params.row.goodsid;
                      this.newCost = params.row.cost;
                      this.selrow = params.row;
                    },
                  },
                },
                "修改成本"
              ),
              parseInt(params.row.procurestatus) == 0
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.selrow = params.row;
                          this.caigouok();
                        },
                      },
                    },
                    "已采购"
                  )
                : null, // 不满足
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.selrow = params.row;
                      this.updateSource = true; // 弹出修改来源弹窗
                      this.selectedSource = ""; // 清空之前的选择
                    },
                  },
                },
                "修改来源"
              ),
              this.row.rows.length > 1 || parseInt(params.row.goodsnum) > 1
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.selrow = params.row;
                          const rownum = this.row && this.row.rows ? this.row.rows.length : 0;
                          if (rownum > 1) {
                            this.chaiConfirmModal = true;
                            return;
                          }

                          const max = (parseInt(params.row.goodsnum, 10) || 0) - 1;
                          this.maxChaiCount = max > 0 ? max : 0;
                          this.chaiCount = "";
                          if (this.maxChaiCount <= 0) {
                            this.$Message.error("当前数量无法拆单");
                            return;
                          }
                          this.caidanmodal = true;
                        },
                      },
                    },
                    "拆单"
                  )
                : null, // 不满足
            ]);
          },
        });
      }

      return baseColumns;
    },
  },
  methods: {
    chaiConfirmOk() {
      this.selrow.rownum = this.row && this.row.rows ? this.row.rows.length : 0;
      this.selrow.chainum = undefined;
      cmsChaiOrder(this.selrow).then((res) => {
        console.log(res);
        this.$emit("triggerQueryGoods"); // 发送事件给父组件
      });
      this.chaiConfirmModal = false;
    },
    caidanok() {
      const max = Number(this.maxChaiCount) || 0;
      const count = parseInt(this.chaiCount, 10);
      if (!count || count <= 0 || !Number.isInteger(count)) {
        this.$Message.error("请输入正确的拆单数量");
        return;
      }
      if (max <= 0) {
        this.$Message.error("当前数量无法拆单");
        return;
      }
      if (count > max) {
        this.$Message.error(`拆单数量不能超过${max}`);
        return;
      }

      this.selrow.rownum = this.row.rows.length;
      this.selrow.chainum = count;
      cmsChaiOrder(this.selrow).then((res) => {
        console.log(res);
        this.$emit("triggerQueryGoods"); // 发送事件给父组件
      });
      this.caidanmodal = false;
    },
    caigouok() {
      cmsCaigouOrder(this.selrow).then((res) => {
        console.log(res);
        this.selrow.procurestatus = 1;
      });
    },
    updateSourceModalOk() {
      if (!this.selectedSource) {
        this.$Message.error("请选择商品来源");
        return;
      }
      if (this.selectedSource == this.selrow.goodssource) {
        this.$Message.warning("商品来源未修改");
        return;
      }
      if (
        this.selectedSource != "本地库" &&
        this.selrow.goodssource == "本地库"
      ) {
        this.laiyuantitle =
          "本地库修改为代发,当前商品将退回至库存,库存数量将增加";
        this.updateSource = false;
        this.laiyuantishi = true;
        return;
      }

      if (
        this.selrow.goodssource != "本地库" &&
        this.selectedSource == "本地库"
      ) {
        this.laiyuantitle =
          "要将代发转换成本地库,当前商品将扣库存,库存数量将减少";
        this.updateSource = false;
        this.laiyuantishi = true;
        return;
      }

      cmsUpdateSource({
        goodsid: this.selrow.goodsid,
        goodsnum: this.selrow.goodsnum,
        orderid: this.selrow.orderid,
        oldsource: this.selrow.goodssource,
        source: this.selectedSource,
        id: this.selrow.id,
      }).then((res) => {
        this.selrow.goodssource = this.selectedSource;
        this.updateSource = false;
        this.$emit("triggerQueryGoods");
      });
    },
    quedinglaiyuan() {
      this.laiyuantishi = false;
      cmsUpdateSource({
        goodsid: this.selrow.goodsid,
        goodsnum: this.selrow.goodsnum,
        orderid: this.selrow.orderid,
        oldsource: this.selrow.goodssource,
        source: this.selectedSource,
        id: this.selrow.id,
      }).then((res) => {
        this.selrow.goodssource = this.selectedSource;
        this.updateSource = false;
        this.$emit("triggerQueryGoods");
      });
    },
    async updateCost() {
      if (!this.newCost) {
        this.$Message.error("请输入成本价");
        return;
      }
      try {
        
        cmsUpdateCost({
          orderid: this.selrow.id,
          cost: this.newCost
      }).then((res) => {
        const index = this.row.rows.findIndex(item => item.goodsid === this.currentGoodsId);
        if (index !== -1) {
          this.row.rows[index].cost = this.newCost;
        }
        this.costModal = false;
        this.$emit("triggerQueryGoods");
       });
      } catch (error) {
        this.$Message.error("修改失败：" + error.message);
      }
    },
  },
};
</script>
